import { useLocation } from "react-router-dom";

export const useCurrentCourseSlug = () => {
  const location = useLocation();
  const match = location.pathname.match(/^\/course\/([^/]+)/);
  if (match) { 
    const slug = match[1];
    localStorage.setItem("activeCourse", slug);
    return slug;
  }

  return localStorage.getItem("activeCourse");
  
};

